module.exports = __webpack_public_path__ + "static/img/b2.997b756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b2.jpg
// module id = mRAE
// module chunks = 0